<template>
  <v-dialog v-model="value" persistent scrollable max-width="655px">
    <v-card class="pa-0">
      <v-toolbar color="headformsdark" height="45" elevation="0" dense dark>
        <v-spacer></v-spacer>
        <span class="mdlHeadForms">{{ sTitle }}</span>
        <v-spacer></v-spacer>
        <v-btn  color="btncolor-dark" @click="onCerrarDialog()" icon small dark outlined>
          <v-icon size="15px">fa fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="max-height: 80vh;" class="pa-1">
        <v-container fluid>
          <v-row class="no-gutters">
            <v-container class="cont-shadown-rounded pa-1" fluid>
              <v-row class="no-gutters">
                <v-col sm="12" cols="12" :md="oItem.cols" :lg="oItem.cols" :xl="oItem.cols" class="pa-1" v-for="(oItem, idx) in aFormItems" :key="'oItem-'+idx">
                  <component 
                    :ref="`form-${oItem.nombre}`"
                    :is="oItem.tipo"
                    v-model="oRegistro[oItem.nombre]"
                    :titulo="oItem.label"
                    :obligatorio="oItem.obligatorio == '1' ? true : false"
                    :condicion="oItem.Condicion"
                    :inner="oItem.innerJoin"
                    :campo="oItem.nombre"
                    :editable="'1'"
                    :campoFiltro="oItem.CampoFiltro"
                    :valorFiltro="oItem.ValorFiltro"
                    @ModificaA="onModificarCampo"
                    :itemsData="oItem.items"
                    :aDataCheck="oItem.checkOptions"
                    >
                  </component>
                </v-col>
                 <v-col cols="12" class="text-center my-1">
                  <v-btn class="mx-auto" color="primary" @click="onAgregarPrioridad" :disabled="bAgregarRiesgo">{{$store.state.jsIdioma.oEquivalencias.btnAgregar}}<v-icon right>mdi-plus</v-icon> </v-btn>
                </v-col>
                 <v-col cols="12" class="my-2">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="12">
                  <FormTabla
                    v-if="oDataTabla.desserts.length > 0"
                    titulo="Prioridades Asociadas"
                    :bDelete="true"
                    :oDataTable="oDataTabla"
                    />
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="mx-auto">
          <v-btn color="btncolor" dark class="mx-1" @click="onCerrarDialog">{{$store.state.jsIdioma.oEquivalencias.btnCancelar}}</v-btn>
          <v-btn color="btncolor" dark class="mx-1" @click="onGuardarRegistro" :loading="cargandoInfo" :class="{'btn-disabled' : cargandoInfo}">{{$store.state.jsIdioma.oEquivalencias.btnGuardar}}</v-btn>
        </div>
      </v-card-actions>
      <ModalMensajeGeneral v-model="oModalMensaje.bModalVisible" :sMensaje="oModalMensaje.sMensaje" :nTipo="oModalMensaje.nTipo"/>
    </v-card>
  </v-dialog>
</template>
<script>
import selector from '@/components/Form/Componentes/FormSelect.vue'
import formlabel from '@/components/Form/Componentes/FormLabel.vue'
import numero from '@/components/Form/Componentes/FormNumero.vue'
import selectordependiente from '@/components/Form/Componentes/FormSelectFiltro.vue'
import FormMultiSelect from '@/components/Form/Componentes/FormMultiSelect.vue'
import FormTextArea from '@/components/Form/Componentes/FormTextArea.vue'
import FormTabla from '@/components/Form/Componentes/FormTabla.vue'
import FormMultipleRadioButton from '@/components/Form/Componentes/FormMultipleRadioButton.vue'
import axiosServices from "@/services/axiosServices.js"
import jsFormulario from "@/Utlidades/FormularioUtils.js"

export default {
  name:'FormAsociarTiempos',
  components: {
    selector,
    numero,
    selectordependiente,
    FormMultiSelect,
    FormMultipleRadioButton,
    FormTextArea,
    FormTabla,
    formlabel
  },
  props:{
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sTitle: 'Asociar tiempos de gestión',
      oModalMensaje: {
        bModalVisible: false,
        sMensaje: '',
        nTipo: 2
      },
      oRegistro: {},
      aFormItems: [],
      oDataTabla:{
        // riesgo , grupoimpacto
        headers: [
          { text: 'Prioridad', value: 'Prioridad', sortable: false},
          { text: 'Tiempo (Días)', value: 'Tiempo_Atencion', sortable: false },
        ],
        desserts: [
          // { riesgo: 'Hurto', grupoimpacto: 'Personas', Borrable : trrue},
        ]
      },
      formselect:[],
      aDataForm:[],
      cargandoInfo : false      // Esta de carga de información 
    }
  },
  mounted() {
    this.onCargarCampos()
  },
  methods: {
    async onCargarCampos(){
      this.bCargando = true
      let sParams = 'sTable=PQR_PrioridadesXDependencias_Tiempo'
      
      const aCampos = await axiosServices.getConfiguration('/formulario_campos',true, sParams)
      this.aFormItems = aCampos.aData
    },
    onCerrarDialog(){
      this.oDataTabla = {
        headers: [
          { text: 'Prioridad', value: 'Prioridad', sortable: false},
          { text: 'Tiempo (Días)', value: 'Tiempo_Atencion', sortable: false },
        ],
        desserts: []
      },
      this.onLimpiarDataFormulario()
      this.$emit('input', false)
    },
    onLimpiarDataFormulario() {
      this.aFormItems.forEach(elemento => elemento.Valor = '')
    },
    onModificarCampo(sCampoModificado, sValor) {
      const nIndex = this.aFormItems.findIndex(oItem => oItem.nombre === sCampoModificado)
      this.aFormItems[nIndex].ValorFiltro = sValor
    },
    onAgregarPrioridad(){
      const aData = this.$refs[`form-Prioridad`][0].itemsData
      if(!this.bAgregarRiesgo){
        const AuxIndex = this.oDataTabla.desserts.findIndex(elemento => elemento.idPrioridad === this.oRegistro.Prioridad )
        const oDataPrioridad = aData.find(elemento => elemento.id === this.oRegistro.Prioridad )
        if( AuxIndex === -1){
          this.oDataTabla.desserts.push({
            Prioridad: oDataPrioridad.texto,
            idPrioridad: this.oRegistro.Prioridad,
            Tiempo_Atencion: this.oRegistro.Tiempo_Atencion,
            Borrable: true
          })
        } else {
          this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
          this.oModalMensaje.sMensaje = 'Ya cuenta con esta Prioridad, para modificar borre y añada los cambios'
        }
        
        delete this.oRegistro.Prioridad
        delete this.oRegistro.Tiempo_Atencion
      }

    },
    async onGuardarRegistro (){
      this.cargandoInfo = true
      const oValidacion = jsFormulario.onValidarCamposObligatorios(this.aFormItems, this.oRegistro)
      const bErrorLength = (this.oDataTabla.desserts.length == 0)
      if(oValidacion.bError){
        this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
        this.oModalMensaje.sMensaje = 'Se require todos los campos obligatorios diligenciados'
        this.oModalMensaje.nTipo = 3
        this.cargandoInfo = false
        return 
      }
      if(bErrorLength){
        this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
        this.oModalMensaje.sMensaje = 'Debe agregar al menos una prioridad'
        this.oModalMensaje.nTipo = 3
        this.cargandoInfo = false
        return 
      }

      this.oRegistro.aPrioridades = this.oDataTabla.desserts

      const axiosGuardar = await axiosServices.postConfiguration('/pqr/tiempos-gestion', this.oRegistro, true)
      this.oModalMensaje.bModalVisible =! this.oModalMensaje.bModalVisible
      this.oModalMensaje.sMensaje = axiosGuardar.sMessage
      this.oModalMensaje.nTipo = 3
      this.cargandoInfo = false
      if(axiosGuardar.nStatusCode === 200) {
        this.$emit('guardado')
        this.onCerrarDialog()
      }
    },
  },
  computed: {
    onIdDepartamento() {
      return (Object.prototype.hasOwnProperty.call(this.oRegistro, 'NombreDepartamento') ? this.oRegistro.NombreDepartamento : '')
    },
    bAgregarRiesgo() {
      if (!Object.prototype.hasOwnProperty.call(this.oRegistro, 'Prioridad')) return true
      if (!Object.prototype.hasOwnProperty.call(this.oRegistro, 'Tiempo_Atencion')) return true
      return !(this.oRegistro.Prioridad != null && this.oRegistro.Prioridad != '' && this.oRegistro.Tiempo_Atencion.length > 0 )
    }
  },
  watch:{
    onIdDepartamento() {
      if(this.onIdDepartamento !== '') {
        this.aFormItems[2].ValorFiltro = this.onIdDepartamento
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.mdlHeadForms{
  font-size: 0.9em;
}
</style>
